const {
    REACT_APP_CHAT_SERVICE_KEY,
    REACT_APP_CHAT_FNS,
} = process.env;

module.exports = {
    CHAT_SERVICE_KEY: REACT_APP_CHAT_SERVICE_KEY || '',
    CHAT_FNS: REACT_APP_CHAT_FNS || '',
};
